import { useCallback, useState } from 'react';

import { TFilesModalMode } from '@widgets/Files/model/types/modalMode.type';

export const usePrevModal = (onHideModal: () => void) => {
    const [secondModal, setSecondModal] = useState<TFilesModalMode>(null);

    const onSecondModal = useCallback((value: TFilesModalMode) => {
        setSecondModal(value);
    }, []);

    const onHideSecondModal = useCallback(() => {
        setSecondModal(null);
        if (secondModal === 'delete') {
            onHideModal();
        }
    }, [onHideModal, secondModal]);

    return { secondModal, onSecondModal, onHideSecondModal };
};
